var ChangePasswordDialog = function () {}

ChangePasswordDialog.install = function (Vue, options) {
	Vue.prototype.$showChangePasswordDialog = function (options) {

		const instance = new DialogConstructor();
		instance.show();

	}
}

// Auto install the plugin.
if (typeof window === "object" && typeof window.Vue === "function") {
	Vue.use(ChangePasswordDialog);
}

const DialogConstructor = Vue.extend({
	template: '<el-dialog :title="\'changePassword.title\' | t" :visible.sync="visible"><el-form :model="form"><el-form-item label="Current password"><el-input type="password" v-model="form.currentPassword"  :placeholder="\'changePassword.oldPassword.placeholder\' | t" auto-complete="off"/></el-form-item><el-form-item label="New password"><el-input type="password" v-model="form.newPassword"  :placeholder="\'changePassword.newPassword.placeholder\' | t" auto-complete="off"/></el-form-item><el-form-item label="Confirm new password"><el-input type="password" v-model="form.confirmPassword"  :placeholder="\'changePassword.newPasswordRepeat.placeholder\' | t" auto-complete="off"/></el-form-item></el-form><span slot="footer" class="dialog-footer"><el-button @click="visible = false">{{ \'changePassword.cancel\' | t }}</el-button><el-button type="primary" @click="changePassword">{{ \'changePassword.confirm\' | t }}</el-button></span></el-dialog>',

	data: function () {
		return {
			visible: true,
			form: {
				currentPassword: "",
				newPassword: "",
				confirmPassword: ""
			}
		}
	},

	watch: {
		visible: function () {
			if (this.visible) {
				this.show();
			} else {
				document.body.removeChild(this.$el);
			}
		}
	},

	methods: {
		show: function () {
			this.$mount();
			document.body.appendChild(this.$el);
		},

		hide: function () {
			this.visible = false;
		},

		validatePassword: function () {

			const validationErrors = [];

			if (!this.form.currentPassword) {
				validationErrors.push(t('changePassword.validation.empty_password'));
			}

			if (!this.form.newPassword) {
				validationErrors.push(t('changePassword.validation.empty_password'));
			}

			if (this.form.newPassword.length < 8) {
				validationErrors.push(t('changePassword.validation.short_password'));
			}

			if (this.form.newPassword !== this.form.confirmPassword) {
				validationErrors.push(t('changePassword.validation.no_match'));
			}

			return validationErrors;

		},

		changePassword: function () {

			const errors = this.validatePassword();

			if (errors.length > 0) {
				this.$message({
					message: errors[0],
					type: "error"
				});
				return;
			}

			httpClient.put(`/users/changepassword`, {
					current_password: this.form.currentPassword,
					password1: this.form.newPassword,
					password2: this.form.confirmPassword
				})
				.then(data => {
					this.$message({
						message: t("changePassword.success"),
						type: "success"
					});
					this.hide();

				})
				.catch(error => {
					this.$message({
						message: errors[0],
						type: "error"
					});
				});

		}
	}

});
